import React, {Component}  from 'react';
import _                   from 'lodash';
import AppActions          from './../../actions/AppActions';

class BoundDecimalInput extends Component {
    render() {
        const { path, value, onChangeListener, getValue, ...componentProps } = this.props;

        const handleChange = event => {
            const element = event.target;
            const _getValue = getValue || (val => val);
            const newValue = Number(_getValue(element.value));

            AppActions.updateState(path, newValue);

            if (_.isFunction(onChangeListener)) {
                onChangeListener(newValue, path, value);
            }
        };

        return (
            <input
                type="number"
                onChange={handleChange}
                {...componentProps}
                value={value}
            />
        );
    }
}

export default BoundDecimalInput;